import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { PublicBillComparisonVm } from 'app/shared/generated/Forms/Models/PublicBillComparisonVm';
import { HttpClient, HttpParams } from '@angular/common/http';


@Component({
    selector: 'pcg-public-bill-comparison',
    templateUrl: './public-bill-comparison.component.html',
    styleUrls: ['./public-bill-comparison.component.scss'],
    standalone: false
})
export class PublicBillComparisonComponent implements OnInit {

  subscriptions = new Subscription();
  formGroup = PublicBillComparisonVm.Form;
	model = PublicBillComparisonVm.GetModel(this.formGroup);
  code: string;
	email: string;
  canGoToForm = false;
  formId: number;

  constructor(private activatedRoute: ActivatedRoute, private ms: SystemMessageService, private httpClient: HttpClient,) { }

  ngOnInit(): void {
    this.formGroup.patchValue(this.model);
    if (this.activatedRoute.snapshot.queryParamMap.get('code') && this.activatedRoute.snapshot.queryParamMap.get('email')) {
			var codeParam = this.activatedRoute.snapshot.queryParamMap.get('code');
			this.code = codeParam;

      var emailParam = this.activatedRoute.snapshot.queryParamMap.get('email');
			this.email = emailParam;

      const httpParams = new HttpParams().set('guidCode', this.code).set('email', this.email);

      this.httpClient.get("api/Forms/BillComparisonForm/VerifyPublicBillComparisonLink", {
        params: httpParams,
      }).subscribe((response: any) => {
        if(response == -1){
            this.ms.setSystemMessage('Invalid link.', 'warning');
          }
          else{
            this.formId = response;
            this.canGoToForm = true;
          }
      });
		}
    else{
      this.ms.setSystemMessage('Invalid link.', 'warning');
    }
  }

}
